export default __webpack_public_path__ + "static/media/clock_icon.bc10a80a.svg";